import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ApiService} from './../../services/api.service';
import {FloatButtonCartService} from './../../components/floatButtonCart/floatButtonCart.service';

@Component({
  selector: 'my-product',
  template: require('./product.component.html')
})
export class ProductComponent implements OnInit {


  public productoDefault = {
    idProducto:null
  };
  public cantidad: number = 1;
  public typeUser: number = 1;

  constructor(private _apiService: ApiService, private _activatedRoute: ActivatedRoute, private _router: Router, private _floatService:FloatButtonCartService) {
    this._activatedRoute.params.subscribe(params => {
      this._apiService.getProducto(params['id']).subscribe(
        result => {
          this.productoDefault = result[0];
        },
        err => {
          console.log(err);
          this._router.navigateByUrl('404');
        }
      );
    })

    if(localStorage.getItem('login')){
      let user = JSON.parse(localStorage.getItem('login'));
      if(user.tipoUsuario == 'cliente'){
        this.typeUser = user.tipoCliente;
      }
    }
  }

  public validationNumber(): void {
    if(this.cantidad <= 0){
      this.cantidad = 1;
    }
    if((this.cantidad%1) > 0){
      this.cantidad = this.cantidad - (this.cantidad%1);
    }
  }

  public addToCart(){
    this._floatService.addToCart(this.productoDefault.idProducto, this.cantidad);
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/product/product.component.ts